import React from 'react';
import LegalLayout from './LegalLayout';

const Privacy = () => (
  <LegalLayout eyebrow="Legal" title="Privacy Policy" updated="1 January 2026">
    <p>Elevate Medical Clinics (“we”, “us”, “our”) is committed to protecting the privacy of our patients and website visitors. This policy explains what information we collect, how we use it, and your rights under the Privacy Act 1988 (Cth) and the Australian Privacy Principles.</p>

    <h2>Information we collect</h2>
    <ul>
      <li>Personal identifiers (name, date of birth, contact details, Medicare number where relevant).</li>
      <li>Health information provided during consultations, investigations and treatment.</li>
      <li>Enquiry information submitted through our website (booking form, contact form, newsletter).</li>
      <li>Standard technical data (IP address, browser, pages viewed) via cookies and analytics.</li>
    </ul>

    <h2>How we use your information</h2>
    <ul>
      <li>To provide medical care, coordinate referrals and manage your treatment.</li>
      <li>To respond to your enquiries and confirm appointments.</li>
      <li>To send you clinic updates and health insights (only where you have opted in).</li>
      <li>To meet our legal, professional and regulatory obligations.</li>
    </ul>

    <h2>Sharing your information</h2>
    <p>We do not sell your personal information. We may share it with other treating clinicians, pathology providers, or with Medicare / private health insurers where clinically or legally required. Third-party service providers (e.g. our practice management and email systems) may process your data on our behalf under appropriate contracts.</p>

    <h2>Data security</h2>
    <p>We use industry-standard technical and organisational measures to protect your information. Health records are stored securely in line with Australian medical record-keeping standards.</p>

    <h2>Your rights</h2>
    <ul>
      <li>Access the personal information we hold about you.</li>
      <li>Correct information that is inaccurate or out of date.</li>
      <li>Withdraw consent for marketing communications at any time.</li>
      <li>Lodge a complaint with us or with the Office of the Australian Information Commissioner (OAIC).</li>
    </ul>

    <h2>Contact us</h2>
    <p>Questions about this policy? Contact our reception at <a href="mailto:reception@elevatemedicalclinics.com.au">reception@elevatemedicalclinics.com.au</a> or +61 432 809 498.</p>
  </LegalLayout>
);

export default Privacy;
